import {
  Component,
  ElementRef,
  Renderer2,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { MultiSelectBase } from '../multi-select-base';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiSelectComponent extends MultiSelectBase {
  constructor(
    renderer: Renderer2,
    utilsService: UtilsService,
    literalService: LiteralService,
    eRef: ElementRef,
  ) {
    super(renderer, utilsService, literalService, eRef);
  }
}
